import { apiWithToken } from '../api';

const resouceUrl = '/tipo_meio_analise';
const token = localStorage.getItem('@token');
let api = apiWithToken(token);

export const load = async (params) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let page = urlParams.has('page') ? { page: urlParams.get('page') } : {};
  let search = urlParams.has('search')
    ? { search: urlParams.get('search') }
    : {};
  return await api.get(`${resouceUrl}`, {
    params: {
      ...params,
      ...page,
      ...search,
    },
  });
};

export const select = async () => {
  return await api.get(`${resouceUrl}?fields=id,nome&raw_list`);
};

export const show = async (id, params) => {
  return await api.get(`${resouceUrl}/${id}`, { params });
}

export const update = async (id, tipo_meio_analise) => {
  return await api.put(`${resouceUrl}/${id}`, tipo_meio_analise);
}


export const store = async (tipo_meio_analise) => {
  let response = await api.post(resouceUrl, tipo_meio_analise);
  return response;
}

export const destroy = async (id) => {
  return await api.delete(`${resouceUrl}/${id}`);
}

export const import_data = async (meio_analise_id, data_file_csv) => {
  let formData = new FormData();
  formData.append('arquivo', data_file_csv);
  formData.append('meio_analise_id', meio_analise_id);

  return await api.post(`${resouceUrl}/import_data`,
    formData,
    meio_analise_id
    , {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
}
